const SITE_NAME = 'TAKAJYU鍼灸・整体院';
const SITE_TAGLINE = '文京区春日駅徒歩1分の鍼灸・整体院';
const DEFAULT_DESCRIPTION =
    '文京区春日駅徒歩1分のTAKAJYU鍼灸・整体院は、神経整体と鍼灸で慢性的な痛みや不調に根本から向き合う完全予約制のプライベートサロンです。';
const DEFAULT_KEYWORDS = [
    'TAKAJYU',
    '鍼灸',
    '整体',
    '神経整体',
    '文京区',
    '春日駅'
];

const seoConfig = {
    '/': {
        title: '文京区春日駅徒歩1分の鍼灸・整体院',
        description:
            '完全予約制のプライベート空間で神経整体と鍼灸を提供するTAKAJYU鍼灸・整体院。慢性痛や不調の根本改善を目指す施術とキャンペーン情報をご紹介します。',
        keywords: [...DEFAULT_KEYWORDS, 'プライベートサロン', '慢性痛', 'キャンペーン'],
        image: '/img/hero-treatment.jpg',
        type: 'website'
    },
    '/concept': {
        title: 'コンセプト',
        description:
            '院長の想いと施術理念、TAKAJYU鍼灸・整体院が大切にする価値観をご紹介。東洋医学と西洋医学を融合したアプローチで心身のバランスを整えます。',
        keywords: [...DEFAULT_KEYWORDS, 'コンセプト', '院長', '施術理念'],
        image: '/img/counseling-session.jpg'
    },
    '/treatments': {
        title: '施術について',
        description:
            '神経整体と鍼灸を中心に自然治癒力を引き出すTAKAJYU鍼灸・整体院の施術方針と来院頻度の目安を解説します。',
        keywords: [...DEFAULT_KEYWORDS, '施術', '来院頻度', '自然治癒力'],
        image: '/img/root-treatment.jpg'
    },
    '/menu': {
        title: 'メニュー・料金',
        description:
            '整体・鍼灸・美容メニューや回数券、オプション料金などTAKAJYU鍼灸・整体院の料金体系をご案内します。',
        keywords: [...DEFAULT_KEYWORDS, '料金', 'メニュー', '回数券'],
        image: '/img/full-body-balance.webp'
    },
    '/reservation': {
        title: 'ご予約・お問い合わせ',
        description:
            'TAKAJYU鍼灸・整体院の予約方法や初回の流れ、LINE・電話でのお問い合わせ先をご紹介。完全予約制で安心してご来院いただけます。',
        keywords: [...DEFAULT_KEYWORDS, '予約', 'お問い合わせ', 'LINE'],
        image: '/img/private-reservation.jpg'
    },
    '/symptoms': {
        title: '症状から探す',
        description:
            '腰痛・肩こり・首・膝の痛みなど、症状から選べる特集ページ。原因やセルフケア、当院の施術方針をまとめています。',
        keywords: [...DEFAULT_KEYWORDS, '腰痛', '肩こり', '症状'],
        image: '/img/acute-pain.jpg'
    },
    '/symptoms/low-back-pain': {
        title: '腰痛の原因と施術',
        description:
            '慢性的な腰痛の原因や神経整体・鍼灸による改善アプローチ、悪化させないためのポイントを詳しく解説します。',
        keywords: [...DEFAULT_KEYWORDS, '腰痛', '神経整体', '鍼灸'],
        image: '/img/hero-treatment.jpg'
    },
    '/symptoms/shoulder-pain': {
        title: '肩こり・五十肩の施術',
        description:
            '肩こりや五十肩の原因と当院の施術ステップ、放置によるリスクや再発予防についてご紹介します。',
        keywords: [...DEFAULT_KEYWORDS, '肩こり', '五十肩', '再発予防'],
        image: '/img/nerve-therapy-trial.webp'
    },
    '/symptoms/neck-pain': {
        title: '首の痛みの施術',
        description:
            '首の痛み・スマホ首などの原因と、TAKAJYU鍼灸・整体院が行う筋・神経への施術、セルフケアの注意点をご案内します。',
        keywords: [...DEFAULT_KEYWORDS, '首の痛み', 'ストレートネック', 'セルフケア'],
        image: '/img/facial-care.webp'
    },
    '/symptoms/knee-pain': {
        title: '膝の痛みの施術',
        description:
            '膝の痛みの代表的な原因や疾患、再発予防を見据えた神経整体・鍼灸の施術と生活改善について解説します。',
        keywords: [...DEFAULT_KEYWORDS, '膝痛', '生活改善', '再発予防'],
        image: '/img/full-body-balance.webp'
    },
    '/access': {
        title: 'アクセス・院情報',
        description:
            'TAKAJYU鍼灸・整体院へのアクセス情報。春日駅A5出口徒歩1分、住所やビルの案内、Googleマップを掲載しています。',
        keywords: [...DEFAULT_KEYWORDS, 'アクセス', '春日駅', '地図'],
        image: '/access/entrance.png'
    },
    '/campaign/nerve-therapy-trial': {
        title: '神経整体お試しキャンペーン',
        description:
            '神経整体25分お試しキャンペーンの内容・価格・対象症状をご紹介。神経にアプローチする施術で根本改善を体験できます。',
        keywords: [...DEFAULT_KEYWORDS, 'キャンペーン', '神経整体', '初回割引'],
        image: '/img/nerve-therapy-trial.webp'
    },
    '/campaign/facial-care': {
        title: '小顔施術キャンペーン',
        description:
            '美容鍼と整体を組み合わせた小顔施術キャンペーンの詳細と効果をご案内。フェイスラインの引き締めと肌質改善をサポートします。',
        keywords: [...DEFAULT_KEYWORDS, '小顔', '美容鍼', 'フェイスライン'],
        image: '/img/facial-care.webp'
    },
    '/campaign/full-body-balance': {
        title: '全身バランス調整キャンペーン',
        description:
            '全身バランス調整50分キャンペーンの概要とおすすめポイント。骨格・筋肉・神経を整えて疲れにくい身体を目指します。',
        keywords: [...DEFAULT_KEYWORDS, '全身調整', '骨格', '疲労回復'],
        image: '/img/full-body-balance.webp'
    }
};

const getSeoByPath = (path = '/') => {
    const normalizedPath = path === '' ? '/' : path;
    return {
        title: SITE_TAGLINE,
        description: DEFAULT_DESCRIPTION,
        keywords: DEFAULT_KEYWORDS,
        type: 'article',
        ...seoConfig[normalizedPath]
    };
};

export { SITE_NAME, SITE_TAGLINE, DEFAULT_DESCRIPTION, DEFAULT_KEYWORDS, seoConfig, getSeoByPath };

